import React from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import SuccessWrap from "../error-success/SuccessWrap";
import ErrorText from "../error-success/ErrorText";

class DeleteConfirmationDialog extends React.PureComponent {
	render() {
		const { deleteSuccess, deleteErrors } = this.props;

		let buttons = [];

		// Deletion was a success
		if (deleteSuccess) {
			buttons = [
				{
					type: Button,
					text: "Ok",
					action: () => {
						this.props.handleClose();

						// Redirect if necessary (admin pages may want to go back to the search component)
						if (!!this.props.handleDeleteRedirect) {
							this.props.handleDeleteRedirect();
						}
					}
				}
			];

			// Delete can still be confirmed
		} else {
			buttons = [
				{
					type: Button,
					text: "Cancel",
					action: () => this.props.handleClose(),
					disabled: this.props.deletionInProgress
				},
				{
					type: Button,
					text: "Yes",
					action: () => this.props.handleDelete(this.props.id),
					disabled: this.props.deletionInProgress
				}
			];
		}

		return this.props.show ? (
			<Modal title={"Confirm Deletion"} buttons={buttons}>
				{/* Loading */}
				{this.props.deletionInProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div> // Show dialog content
				) : (
					<div>
						{deleteSuccess ? (
							<SuccessWrap animate={1}>{deleteSuccess}</SuccessWrap>
						) : (
							<div>
								<div>
									Are you sure you want to delete this item
									{this.props.itemTitle ? (
										<span>
											:{" "}
											<div className="item_name_block">
												{this.props.itemTitle}
											</div>
										</span>
									) : (
										"?"
									)}
								</div>
								{deleteErrors && <ErrorText animate={1} errors={deleteErrors} />}
							</div>
						)}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default DeleteConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/DeleteConfirmationDialog.js